import React from "react";

const Shop = () => {
    return (
        <div>
            <h1>Shop</h1>
            <p>Welcome to the Shop page.</p>
        </div>
    );
};

export default Shop;